import { API_DATA } from '../../middleware/apiService';
import types from './types';

export function toggleMenu(menuActive) {
  return {
    type: types.TOGGLE_MENU,
    payload: menuActive,
  };
}

export function toggleFullScreen(active) {
  return {
    type: types.TOGGLE_FULL_SCREEN,
    payload: active,
  };
}

export function toggleSidebar(hidden, id, entity) {
  return {
    type: types.TOGGLE_SIDEBAR,
    hidden: hidden,
    id: id,
    entity: entity,
  };
}

export function toggleMailSidebar(hidden, id, user) {
  return {
    type: types.TOGGLE_MAIL_SIDEBAR,
    hidden,
    id,
    user,
    entity: 'MailItem',
  };
}

export function userFailure(error) {
  return { type: types.USER_FAILURE, error };
}

function uploadImage(file, endpoint) {
  let imageEndpoint = 'resources/image/upload';
  if (endpoint) {
    imageEndpoint = endpoint;
  }
  return {
    [API_DATA]: {
      types: [types.UPLOAD_IMAGE_REQUEST, types.UPLOAD_IMAGE_SUCCESS, types.UPLOAD_IMAGE_FAILURE],
      endpoint: imageEndpoint,
      params: {
        requestBody: {
          file: file,
        },
        contentType: false,
      },
    },
  };
}

function uploadImages(file) {
  return {
    [API_DATA]: {
      types: [types.UPLOAD_IMAGE_REQUEST, types.UPLOAD_IMAGE_SUCCESS, types.UPLOAD_IMAGE_FAILURE],
      endpoint: 'resources/image/bulkUpload',
      params: {
        requestBody: {
          file: file,
        },
        contentType: false,
      },
    },
  };
}

function uploadDocuments(file) {
  return {
    [API_DATA]: {
      types: [types.UPLOAD_DOCUMENT_REQUEST, types.UPLOAD_DOCUMENT_SUCCESS, types.UPLOAD_DOCUMENT_FAILURE],
      endpoint: 'resources/document/bulkUpload',
      params: {
        requestBody: {
          file: file,
        },
        contentType: false,
      },
    },
  };
}

function uploadFile(file, endPoint, payLoad) {
  let data = {
    file: file,
  };
  if (payLoad) {
    Object.assign(data, payLoad);
  }
  return {
    [API_DATA]: {
      types: [types.UPLOAD_FILE_REQUEST, types.UPLOAD_FILE_SUCCESS, types.UPLOAD_FILE_FAILURE],
      endpoint: endPoint,
      params: {
        requestBody: {
          ...data,
        },
        contentType: false,
      },
    },
  };
}

export function loginRequest(username, password, clientInformation, application = types.APPLICATION_ID) {
  return {
    [API_DATA]: {
      types: [types.USER_REQUEST, types.USER_SUCCESS, types.USER_FAILURE],
      endpoint: 'login',
      params: {
        requestBody: {
          username: username,
          password: password,
          clientInformation: clientInformation,
          application: application,
        },
      },
    },
  };
}

export function loginRequestModal(username, password, company, application = types.APPLICATION_ID) {
  return {
    [API_DATA]: {
      types: [types.MODAL_USER_REQUEST, types.MODAL_USER_SUCCESS, types.MODAL_USER_FAILURE],
      endpoint: 'login',
      params: {
        requestBody: {
          username: username,
          password: password,
          companyId: company.id,
          application: application,
        },
      },
    },
  };
}

export function versionInfo() {
  return {
    [API_DATA]: {
      types: [types.VERSION_REQUEST, types.VERSION_SUCCESS, types.VERSION_FAILURE],
      endpoint: 'application/status',
      method: 'GET',
      params: {},
    },
  };
}

export function updateUser(user) {
  return {
    type: types.USER_SUCCESS,
    response: user,
  };
}

export function addMenuToStore(menu) {
  return {
    type: types.MENU_UPDATE_SUCCESS,
    menu,
  };
}

export function requestPasswordReset(userName) {
  return {
    [API_DATA]: {
      types: [
        types.REQUEST_PASSWORD_RESET_REQUEST,
        types.REQUEST_PASSWORD_RESET_SUCCESS,
        types.REQUEST_PASSWORD_RESET_FAILURE,
      ],
      endpoint: `system/SystemUser/requestPasswordReset`,
      params: {
        requestBody: { userName },
      },
    },
  };
}

export function resetPassword(username, password, token) {
  return {
    [API_DATA]: {
      types: [types.PASSWORD_RESET_REQUEST, types.PASSWORD_RESET_SUCCESS, types.PASSWORD_RESET_FAILURE],
      endpoint: `system/SystemUser/resetPassword`,
      params: {
        requestBody: {
          username: username,
          password: password,
          resetVerification: token,
        },
      },
    },
  };
}

export function switchCompany(systemCompany) {
  return { type: types.SWITCH_COMPANY_SUCCESS, systemCompany };
}

export function loginRedirect() {
  return {
    type: types.LOGIN_REDIRECT,
    message: 'You are currently logged out, please login to continue',
  };
}

export function clearLogin() {
  return {
    type: types.CLEAR_LOGIN,
    message: 'You are now logged in',
  };
}

export function logoutUser() {
  return {
    [API_DATA]: {
      types: [types.LOGOUT_USER_REQUEST, types.LOGOUT_USER_SUCCESS, types.LOGOUT_USER_FAILURE],
      endpoint: `session/logout`,
      params: {
        requestBody: {},
      },
    },
  };
}

export function dismissAuthAlert() {
  return { type: types.DISMISS_AUTH_ALERT };
}

export function focusArea(area, autoFocus) {
  return { type: types.FOCUS_AREA, area: area, autoFocus: autoFocus };
}

export function setActionEntities(actionEntities) {
  return { type: types.SET_ACTION_ENTITIES, actionEntities: actionEntities };
}

export function setExpandedRow(prefix = 'default', rowIndex, options) {
  return { type: types.SET_EXPANDED_ROW, prefix, rowIndex, options };
}

export function prompt(question, options, autoClose = true) {
  return { type: types.PROMPT, question, options, autoClose };
}

/**
 * @deprecated - We no longer need to initialize jobs via this method - Can dispatch directly (dispatchJobToast from useP4ToastController)
 *             - or via a helper hook (useBackgroundMutation, useBackgroundProcess)
 *             - The job notification will poll for job status and call 'updateJobStatus' which will maintain the tracker in redux.
 */
export function startJob(job) {
  return { type: types.START_JOB, job };
}

export function backgroundJob(job) {
  return { type: types.BACKGROUND_JOB, job };
}

export function completeJob(job) {
  return { type: types.COMPLETE_JOB, job };
}

export function failJob(job) {
  return { type: types.FAIL_JOB, job };
}

export function updateJobStatus(job) {
  return { type: types.UPDATE_JOB, job };
}

export function storeURL(url) {
  return { type: types.STORE_URL, url: url };
}

export default {
  toggleMenu,
  toggleFullScreen,
  toggleSidebar,
  toggleMailSidebar,
  userFailure,
  loginRequest,
  versionInfo,
  updateUser,
  requestPasswordReset,
  resetPassword,
  switchCompany,
  loginRedirect,
  logoutUser,
  dismissAuthAlert,
  focusArea,
  setActionEntities,
  startJob,
  backgroundJob,
  completeJob,
  failJob,
  updateJobStatus,
  storeURL,
  uploadImage,
  uploadImages,
  uploadDocuments,
  uploadFile,
  addMenuToStore,
  loginRequestModal,
  clearLogin,
};
